<template>
    <VueMultiselect
        :id="inputId || null"
        v-model="selectedOrganization"
        track-by="id"
        label="name"
        :placeholder="placeholder"
        data-test-id="organization-selector-dropdown"
        :allow-empty="allowClear"
        :options="selectableOrganizations"
        :show-labels="false"
        :disabled="selectableOrganizations.length === 0 || disabled"
        @update:model-value="$emit('update', $event ? $event.id : null)"
    >
        <template
            v-if="allowClear"
            #clear="props"
        >
            <div
                v-if="organizationId"
                class="multiselect__clear"
                @mousedown.prevent.stop="clearAll(props.search)"
            ></div>
        </template>
    </VueMultiselect>
</template>

<script>
import { mapGetters } from 'vuex'
import VueMultiselect from 'vue-multiselect'
import store from '@/store'
import 'vue-multiselect/dist/vue-multiselect.css'

export default {
    name: 'OrganizationSelector',

    components: {
        VueMultiselect,
    },

    props: {
        allowClear: {
            required: false,
            type: Boolean,
            default: false,
        },
        disabled: {
            required: false,
            type: Boolean,
            default: false,
        },
        excludeIds: {
            required: false,
            type: Array,
            default: () => [],
        },
        // Lands on the multiselect's own search input — the element that
        // actually takes focus. A call site pairs it with a <label for> so the
        // control has an accessible name; a placeholder is not one (SC 4.1.2).
        inputId: {
            required: false,
            type: String,
            default: '',
        },
        organizationId: {
            required: false,
            type: Number,
        },
        placeholder: {
            required: false,
            type: String,
            default: 'Choose an organization',
        },
    },

    emits: ['update'],

    data() {
        return {
            selectedOrganization: null,
        }
    },

    computed: {
        ...mapGetters('organizations', ['allOrganizations']),

        selectableOrganizations() {
            if (this.excludeIds.length === 0) {
                return this.allOrganizations
            }

            return this.allOrganizations.filter((organization) => !this.excludeIds.includes(organization.id))
        },
    },

    watch: {
        allOrganizations(newOrganizations) {
            if (this.organizationId !== null && this.selectedOrganization === null) {
                this.selectedOrganization = newOrganizations.find((o) => o.id === this.organizationId)
            }
        },

        organizationId(newId) {
            if (this.selectedOrganization?.id !== newId) {
                this.selectedOrganization = this.allOrganizations.find((o) => o.id === newId)
            }
        },
    },

    mounted() {
        store.dispatch('organizations/refreshOrganizations')
    },

    methods: {
        clearAll() {
            this.$emit('update', null)
        },
    },
}
</script>

<style scoped lang="scss">
.multiselect {
    font-family: 'Avenir';

    div.multiselect__clear {
        position: absolute;
        right: 41px;
        height: 40px;
        width: 40px;
        display: block;
        cursor: pointer;
        z-index: 3;

        unicode-bidi: isolate;
    }

    .multiselect__clear:before {
        transform: rotate(45deg);
    }

    .multiselect__clear:after {
        transform: rotate(-45deg);
    }

    .multiselect__clear:before,
    .multiselect__clear:after {
        content: '';
        display: block;
        position: absolute;
        width: 3px;
        height: 16px;
        background: #aaa;
        top: 12px;
        right: 4px;
    }
}
</style>
